module.exports = __webpack_public_path__ + "static/media/icon-dropdown-down.9b86857e.svg";